import React from 'react';
import { InputAdornment } from 'components/InputBase';
import TextField, { TextFieldProps } from 'components/TextField';
import { Email } from 'icons';

export interface EmailFieldProps extends TextFieldProps {}

/**
 * A wrapper around `TextField` to create a reusable email input
 */
export const EmailField = React.forwardRef<HTMLInputElement, EmailFieldProps>(
  (props, ref) => (
    <TextField
      aria-label="email field"
      placeholder="Email"
      ref={ref}
      startAdornment={
        <InputAdornment position="start">
          <Email />
        </InputAdornment>
      }
      {...props}
    />
  ),
);

export default EmailField;
